import { normalizeSnowflakeId } from '@/utils/common';

/**
 * 将 /web/v1/staff/detail 等接口返回的员工详情规范为 SwimStaffDetailVo。
 * 后端常把 id、roleId、gymId 等以字符串返回，status 可能为 0/1，需与前端类型及严格相等判断对齐。
 * gymId 为雪花 ID，必须保持字符串，禁止 Number()，否则会超过 MAX_SAFE_INTEGER 丢精度。
 */
export function normalizeSwimStaffDetailVo(
  raw: API.SwimStaffDetailVo | Record<string, unknown> | undefined | null,
): API.SwimStaffDetailVo | undefined {
  if (raw == null || typeof raw !== 'object') {
    return undefined;
  }
  const r = raw as Record<string, unknown>;
  const num = (v: unknown): number | undefined => {
    if (v == null || v === '') return undefined;
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
  };
  const str = (v: unknown): string | undefined =>
    v == null || v === '' ? undefined : String(v);
  const optNum = (v: unknown): number | undefined => {
    if (v === null || v === undefined || v === '') return undefined;
    return num(v);
  };

  let status: boolean | undefined;
  if (typeof r.status === 'boolean') {
    status = r.status;
  } else if (r.status === 0 || r.status === '0') {
    status = false;
  } else if (r.status === 1 || r.status === '1') {
    status = true;
  }

  return {
    id: num(r.id),
    gymId: normalizeSnowflakeId(
      r.gymId as string | number | null | undefined,
    ),
    name: str(r.name),
    phone: str(r.phone),
    status,
    statusName: str(r.statusName),
    roleId: num(r.roleId),
    roleName: str(r.roleName),
    side: str(r.side),
    deptId: optNum(r.deptId),
    deptName:
      r.deptName === null || r.deptName === undefined || r.deptName === ''
        ? undefined
        : str(r.deptName),
    createTime: str(r.createTime),
    updateTime: str(r.updateTime),
  };
}
